import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { SubscriptionBundlesVM } from '../../viewModel/subscriptionBundles.viewModel';
import { Textarea } from '@design-system/components/textarea/textarea';
import { Controller } from 'react-hook-form';
import {
  buttonStyle,
  buttonsWrapper,
  textareaStyle,
  wrapper,
} from './SendPushNotificationModal.css';

type SendPushNotificationModalProps =
  SubscriptionBundlesVM['pushNotificationModal'];

export const SendPushNotificationModal: React.FC<
  SendPushNotificationModalProps
> = ({ isOpen, close, save, title, control, submitting }) => (
  <Modal isOpen={isOpen} onClose={close} title={title}>
    <div className={wrapper}>
      <Typography>
        This notification will be sent to all users that have the Playbook
        platform subscription.
      </Typography>
      <Controller
        name={'message'}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Textarea
            label="Push notification"
            maxLength={100}
            required
            value={value}
            onChange={onChange}
            error={error?.message}
            disabled={submitting}
            className={textareaStyle}
          />
        )}
      />
      <div className={buttonsWrapper}>
        <Button
          variant="text"
          color="neutral"
          onClick={close}
          className={buttonStyle}
          data-testid="subscription-cancel-push-notification"
        >
          Go back
        </Button>
        <Button
          color="neutral"
          onClick={save}
          loading={submitting}
          disabled={submitting}
          className={buttonStyle}
          data-testid="subscription-send-push-notification"
        >
          Send
        </Button>
      </div>
    </div>
  </Modal>
);
